import {
  obtainAccessToken,
  generateAccountLoginUrl,
} from "./customerAccountApi";
import { trackAddToCart } from "../../helpers/dataLayer";

const loginToCustomerAccountsApi = () => {
  generateAccountLoginUrl.then((url) => {
    window.location = url;
  });
};

const obtainAccessTokenPromise = obtainAccessToken().then(
  ({ success, initialLogin }) => {
    if (initialLogin) {
      window.location = `${window.location.origin}/account/login`;
    }
    if (!success) {
      if (window.theme.customer_id) {
        loginToCustomerAccountsApi();
      }

      return;
    }

    try {
      const customerAccessData = localStorage.getItem("customer-access-data");
      const { access_token } = customerAccessData
        ? JSON.parse(customerAccessData)
        : { access_token: null };

      if (access_token && !window.theme.customer_id) {
        console.log(
          "Customer is logged in to the Customer Accounts API but not the Liquid storefront",
        );
        // Customer is logged in to the Customer Accounts API but not the Liquid storefront
        // redirect to trigger login to Liquid storefront
        window.location = `${window.location.origin}/account/login`;
        return;
      } else if (window.theme.customer_id && !access_token) {
        console.log(
          `Customer is logged in to the Liquid storefront but not to Customer Account API`,
        );
        // Customer is logged in to the Liquid storefront but not to Customer Account API
        // redirect user to log in to Customer Accounts API
        loginToCustomerAccountsApi();
      }

      const companyLocationId = window.theme.location_id
        ? `gid://shopify/CompanyLocation/${window.theme.location_id}`
        : undefined;

      if (access_token) {
        persistentCartHeaders["x-cart-access-token"] = access_token;
      }

      if (companyLocationId) {
        persistentCartHeaders["x-cart-company-location-id"] = companyLocationId;
      }

      return access_token;
    } catch (error) {
      console.warn("Error obtaining access token", error);
    }
  },
);

/**
 * Change an item in the cart
 * @param {Object|Array} items [{ id, quantity }]
 * @param {Object} options object of callbacks
 */
window.changeCart = (change, options = {}) => {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }

  const sections = [...document.querySelectorAll("[cart-section-id]")].map(
    (el) => el.getAttribute("cart-section-id"),
  );

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...change, sections: sections.join() }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 422) {
        if (options?.onError) {
          options.onError(response);
        }

        return;
      }

      const updateCart = new CustomEvent("updateCart", {
        detail: {
          cart: response,
          data: options.data,
        },
      });
      document.dispatchEvent(updateCart);

      if (options?.onAfterAdd) {
        options.onAfterAdd(response);
      }
    })
    .catch((error) => {
      if (options?.onError) {
        options.onError(error);
      }

      console.error("Cart action failed:", error);
    });
};

/**
 * Remove an item from the cart
 * @param {Object|Array} items [{ id, quantity }]
 * @param {Object} options object of callbacks
 */
window.updateCart = (updates, options = {}) => {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }

  const sections = [...document.querySelectorAll("[cart-section-id]")].map(
    (el) => el.getAttribute("cart-section-id"),
  );

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...updates, sections: sections.join() }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 422 && response.message === "Cart Error") {
        if (options?.onError) {
          options.onError(response);
        }

        return;
      }

      const updateCart = new CustomEvent("updateCart", {
        detail: {
          cart: response,
          data: options.data,
        },
      });
      document.dispatchEvent(updateCart);

      if (options?.onAfterAdd) {
        options.onAfterAdd(response);
      }
    })
    .catch((error) => {
      if (options?.onError) {
        options.onError(error);
      }

      console.error("Cart action failed:", error);
    });
};

/**
 * Add an item to cart. Once it's in, dl_add_to_cart is pushed for every item
 * carrying `tracking`.
 * @param {Object|Array} items [{ id, quantity, tracking }] — `tracking` as
 *        dataLayer's cartItemTracking builds it, and never sent to the cart
 * @param {Object} options object of callbacks, plus `tracking`: { properties }
 *        for the event and every item — see ADD_TO_CART_SOURCES — or false to
 *        push nothing
 */
window.addToCart = (items, options = {}) => {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }
  if (!Array.isArray(items)) {
    items = [items];
  }

  const sections = [...document.querySelectorAll("[cart-section-id]")].map(
    (el) => el.getAttribute("cart-section-id"),
  );

  const data = {
    items: items.map(({ tracking, ...item }) => item),
    sections: sections.join(),
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }

      return response.json().then((errorDetails) => {
        return Promise.reject(errorDetails);
      });
    })
    .then((response) => {
      const sections = response.sections;

      // Tracking must never fail the add itself.
      try {
        if (options.tracking !== false) {
          trackAddToCart(items, options.tracking?.properties);
        }
      } catch (error) {
        console.warn("Unable to track add to cart", error);
      }

      fetch("/cart.js", {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          const updateCart = new CustomEvent("updateCart", {
            detail: {
              cart: { ...response, sections },
              data: options.data,
            },
          });
          document.dispatchEvent(updateCart);
        });

      if (options?.onAfterAdd) {
        options.onAfterAdd(response);
      }
    })
    .catch((error) => {
      if (options?.onError) {
        options.onError(error);
      }

      console.error("Cart action failed:", error);
    });
};
